import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Admin.css';

function Admin() {
  const navigate = useNavigate();

  return (
    <div className="admin-container">
      <h1>Admin Page</h1>
      <button onClick={() => navigate('/admin/create-blog')}>Create Blog</button>
      <button onClick={() => navigate('/blog')}>Edit or Delete Blogs</button>
      <button onClick={() => navigate('/admin/view-emails')}>View Emails</button>
      <button onClick={() => navigate('/admin/topbar')}>Edit heading</button>
    </div>
  );
}

export default Admin;